/*
    Domain may only contain lowercase letters, digits, hyphens (-) and dots (.)
*/
const DOMAIN_REGEXP = /^[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/;

const DOMAIN_RULE_MESSAGE = "Erlaubt sind nur Kleinbuchstaben, Zahlen, Bindestriche (-) und Punkte (.).";

export function domainRule(message = DOMAIN_RULE_MESSAGE): (value: any) => boolean | string {
  return (value) => DOMAIN_REGEXP.test(value) || message;
}

export function domainOptionalRule(message = DOMAIN_RULE_MESSAGE): (value: any) => boolean | string {
  return (value) => DOMAIN_REGEXP.test(value) || value == "" || message;
}

/*
    Validates a list of domains (e.g. the value of a multiple v-combobox).
    Empty / undefined lists and empty entries are considered valid (optional).
    The underlying rule is built once and reused for every entry to avoid
    rebuilding the rule (and RegExp) per domain.
*/
export function domainsOptionalRule(
  message = DOMAIN_RULE_MESSAGE
): (value: string[] | undefined | null) => boolean | string {
  const rule = domainOptionalRule(message);

  return (value) => {
    if (!value?.length) return true;

    for (const domain of value) {
      const result = rule(domain);
      if (result !== true) return result;
    }

    return true;
  };
}
